export const TABS_OPTIONS = [
  { label: 'Organization details', value: 'general' },
  {
    label: 'Vendor users',
    value: 'vendor_users'
  }
]
export const TABS_OPTIONS_VENDORS_CONTRACT_ADMIN = [
  { label: 'Organization details', value: 'general' },
  {
    label: 'Vendor users',
    value: 'vendor_users'
  },
  {
    label: 'Banking setup',
    value: 'banking_setup'
  },
  {
    label: 'Bank accounts',
    value: 'bank_accounts',
    disabled: true
  }
]

export const TABS_OPTIONS_KEY = {
  general: 'general',
  vendor_users: 'vendor_users',
  banking_setup: 'banking_setup',
  bank_accounts: 'bank_accounts',
  users: 'users',
  health_systems: 'health_systems'
}
